import { Model } from "pinia-orm";

export default class ActionPlan extends Model {
  static entity = "actionPlans";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      createdAt: this.string(""),
      updatedAt: this.string(""),

      auditUuid: this.string(null),

      correctiveActions: this.string(""),
      completedActions: this.string(""),
    };
  }
}
